export default __webpack_public_path__ + "src/images/packages/clifftop-exclusive-safari/aca582cbe9af4d3ccaa98ebcbb6e6c3d-2.jpeg";